import { Collapse, Flex, Table } from 'antd';

const columns = [
    {
        title: 'Loại',
        dataIndex: 'title',
        key: 'title',
    },
    {
        title: 'Tham số',
        dataIndex: 'parameter',
        key: 'parameter',
    },
    {
        title: 'Kiểu dữ liệu',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: 'Mô tả',
        dataIndex: 'description',
        key: 'description',
    },
];

const dataSource = [
    {
        title: 'Params',
        parameter: 'order_id',
        type: 'Number | String',
        description: 'ID đơn website muốn lấy thông tin chi tiết',
    },
];

const responseSuccess = {
    data: {
        template: {
            id: 23176528,
            title: 'Web clone trang nạp thẻ của Garena',
        },
        cloudflare: {
            name: 'test.com',
            status: 'pending',
            name_servers: ['lennon.ns.cloudflare.com', 'love.ns.cloudflare.com'],
            original_name_servers: ['ns1.safesecureweb.com', 'ns2.safesecureweb.com', 'ns3.safesecureweb.com'],
        },
        auto_renew: false,
        id: 19777564,
        status: 'confirming',
        app_domain: 'test.com',
        email_admin: 'test.com@thegioicode.com',
        description: 'Vui lòng trỏ Nameservers gốc về Nameservers mới của chúng tôi!',
        admin_domain: 'admin.test.com',
        password_admin: 'ktC7AI9t#Y#K',
        created_at: '2025-05-19 21:06:16',
        expired_at: '2025-08-19 23:59:59',
    },
    status: 200,
    message: 'Lấy chi tiết đơn tạo website thành công',
};

function OrderDetail() {
    return (
        <Collapse
            items={[
                {
                    key: '1',
                    label: <div className="font-bold text-hover">Chi tiết website đã khởi tạo</div>,
                    children: (
                        <div>
                            <Flex align="center">
                                <span className="document-method text-success font-bold">GET</span>
                                <span className="document-method flex-1 text-start">
                                    https://thegioicode.com/api/v2/templates/orders/:order_id
                                </span>
                            </Flex>

                            <Table className="mt-4" bordered columns={columns} dataSource={dataSource} pagination={false} />

                            <div className="mt-3 mb-1">Thành công:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy success">{JSON.stringify(responseSuccess, null, 2)}</code>
                                    </pre>
                                </div>
                            </div>

                            <div className="mt-3 mb-1">Thất bại:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy">
                                            {JSON.stringify({ status: 'Mã code lỗi', error: 'Thông tin lỗi trả về' }, null, 4)}
                                        </code>
                                    </pre>
                                </div>
                            </div>
                        </div>
                    ),
                },
            ]}
        />
    );
}

export default OrderDetail;
